var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    clipRule: "evenodd",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 1.5,
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-525.87 -300.28)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.071228 0 0 .071431 488.41 278.83)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(16.719 0 0 23.812 -8266.3 -6849.8)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 525.87,
    y: 300.28,
    width: 20.153,
    height: 14.11,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-46.646 -31.109)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m760.06 518.05 55.989 55.989",
    fill: "none",
    stroke: "#616474",
    strokeWidth: "15px"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-23.326 -7.4182)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m760.06 518.05 55.989 55.989",
    fill: "none",
    stroke: "#616474",
    strokeWidth: "30px"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-5.9228 -2.9614)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 664.45,
    cy: 435.97,
    r: 77.181,
    fill: "none",
    stroke: "#616474",
    strokeWidth: "30px"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.2cfb97ee7f5f5a5f23dd68785489bfaa.svg";
export { ForwardRef as ReactComponent };